module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-form-wrap-row spacing-height"
  }, [_c('div', {
    staticClass: "input-label"
  }, [(_vm.required) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "input-form",
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "disabled": _vm.isEditServOrder == '1'
    }
  }, [_vm._v(_vm._s(_vm.oneText))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": _vm.isEditServOrder == '1'
    }
  }, [_vm._v(_vm._s(_vm.twoText))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-462a8bb8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/orderCreate/RadioField.vue
// module id = 631
// module chunks = 0